@if (loading) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
} @else if (notFound || !item) {
  <mat-card class="card-style px-6 py-8 text-center">
    <div class="text-lg text-gray-700 mb-4">OS não encontrada ou não pertence a você.</div>
    <button mat-flat-button class="btn-tg-white" (click)="back()">Voltar para minhas OSs</button>
  </mat-card>
} @else {
  <div class="flex justify-between items-center mb-4">
    <div class="text-xl text-gray-700 font-bold">OS {{ item.ordemServicoId }}</div>
    <button class="btn-icon" matTooltip="Voltar" (click)="back()">
      <mat-icon>arrow_back</mat-icon>
    </button>
  </div>

  @if (motivoReajusteDisplay) {
    <div class="avisos-callout mb-4">
      <mat-icon class="icon-inline">warning</mat-icon>
      <span><b>Motivo do reajuste:</b> {{ motivoReajusteDisplay }} — corrija e confirme novamente.</span>
    </div>
  }

  @if (avisosAtribuicao.length > 0) {
    <div class="avisos-callout mb-4">
      <mat-icon class="icon-inline">warning</mat-icon>
      <ul>
        @for (aviso of avisosAtribuicao; track aviso) {
          <li>{{ aviso }}</li>
        }
      </ul>
    </div>
  }

  <mat-card class="card-style px-6 py-4">
    <div class="view-section">
      <div class="section-title">
        <mat-icon class="section-icon">schedule</mat-icon>
        Datas e Horários
      </div>
      <div class="fields-grid">
        <div class="field-item">
          <span class="field-label">Início</span>
          <span class="field-value">{{ displayValue(item.dataInicio) }} {{ formatTime(item.horaInicio) }}</span>
        </div>
        <div class="field-item">
          <span class="field-label">Final</span>
          <span class="field-value">{{ displayValue(item.dataFinal) }} {{ formatTime(item.horaFinal) }}</span>
        </div>
        <div class="field-item">
          <span class="field-label">Status</span>
          <span class="field-value">{{ formatStatus(displayValue(item.descricaoStatus)) }}</span>
        </div>
        <div class="field-item">
          <span class="field-label">Trecho</span>
          <span class="field-value">{{ trechoOsDisplay }}</span>
        </div>
      </div>
    </div>

    <div class="view-section">
      <div class="section-title">
        <mat-icon class="section-icon">payments</mat-icon>
        Valores
      </div>
      <div class="fields-grid">
        <div class="field-item">
          <span class="field-label">Valor total</span>
          <span class="field-value">{{ formatCurrency(item.valorTotal) }}</span>
        </div>
        <div class="field-item">
          <span class="field-label">Prazo de pagamento</span>
          <span class="field-value">{{ item.prazoPagamento ? item.prazoPagamento + ' dias' : '-' }}</span>
        </div>
      </div>
    </div>

    @if (item.nomeConsultorOperacional || item.obsFornecedorOperador) {
      <div class="view-section">
        <div class="section-title">
          <mat-icon class="section-icon">person_pin</mat-icon>
          Equipe TG
        </div>
        @if (item.nomeConsultorOperacional) {
          <div class="fields-grid mb-2">
            <div class="field-item">
              <span class="field-label">Consultor operacional</span>
              <span class="field-value">{{ item.nomeConsultorOperacional }}</span>
            </div>
          </div>
        }
        @if (item.obsFornecedorOperador) {
          <p class="obs-text">{{ item.obsFornecedorOperador }}</p>
        }
      </div>
    }

    <div class="view-section">
      <div class="section-title">
        <mat-icon class="section-icon">groups</mat-icon>
        Passageiros
      </div>
      <mat-accordion>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>Passageiros ({{ item.passageiros?.length || 0 }})</mat-panel-title>
          </mat-expansion-panel-header>
          @if (item.passageiros && item.passageiros.length > 0) {
            <div class="passengers-table-wrap">
              <table mat-table [dataSource]="item.passageiros" class="mat-elevation-z8">
                <ng-container matColumnDef="nome">
                  <th mat-header-cell *matHeaderCellDef>Nome</th>
                  <td mat-cell *matCellDef="let p">{{ displayValue(p.nome) }}</td>
                </ng-container>
                <ng-container matColumnDef="documento">
                  <th mat-header-cell *matHeaderCellDef>Documento</th>
                  <td mat-cell *matCellDef="let p">{{ displayValue(p.documento) }}</td>
                </ng-container>
                <ng-container matColumnDef="contato">
                  <th mat-header-cell *matHeaderCellDef>Contato</th>
                  <td mat-cell *matCellDef="let p">{{ displayValue(p.contato) }}</td>
                </ng-container>
                <ng-container matColumnDef="periodo">
                  <th mat-header-cell *matHeaderCellDef>Data / Horário</th>
                  <td mat-cell *matCellDef="let p">{{ displayValue(p.data) }} {{ formatTime(p.horario) }}</td>
                </ng-container>
                <ng-container matColumnDef="trecho">
                  <th mat-header-cell *matHeaderCellDef>Trecho</th>
                  <td mat-cell *matCellDef="let p">{{ trechoPassageiroDisplay(p) }}</td>
                </ng-container>
                <ng-container matColumnDef="voo">
                  <th mat-header-cell *matHeaderCellDef>Voo</th>
                  <td mat-cell *matCellDef="let p">
                    {{ p.companhia || p.voo ? (displayValue(p.companhia) + ' ' + displayValue(p.voo)) : '-' }}
                  </td>
                </ng-container>
                <tr mat-header-row class="style-header" *matHeaderRowDef="displayedPassengerColumns"></tr>
                <tr mat-row class="style-row" *matRowDef="let row; columns: displayedPassengerColumns"></tr>
              </table>
            </div>
          } @else {
            <p class="text-sm text-gray-500 py-2">Nenhum passageiro vinculado a esta OS.</p>
          }
        </mat-expansion-panel>
      </mat-accordion>
    </div>

    <div class="view-section">
      <div class="section-title">
        <mat-icon class="section-icon">person</mat-icon>
        Motorista
      </div>
      <div class="flex justify-between items-center">
        <span class="field-value">
          <mat-icon
            class="icon-inline"
            [ngClass]="item.temMotoristaAtribuido ? 'color-ok' : 'color-pending'"
            [fontIcon]="item.temMotoristaAtribuido ? 'check_circle' : 'radio_button_unchecked'"
          />
          {{ item.temMotoristaAtribuido && item.motorista ? item.motorista.nome + ' - ' + item.motorista.cpf : 'Não atribuído' }}
        </span>
        <button mat-flat-button class="btn-tg-white" (click)="assignDriver()">
          {{ item.temMotoristaAtribuido ? 'Trocar motorista' : 'Atribuir motorista' }}
        </button>
      </div>
    </div>

    <div class="view-section">
      <div class="section-title">
        <mat-icon class="section-icon">directions_car</mat-icon>
        Veículo
      </div>
      <div class="flex justify-between items-center">
        <span class="field-value">
          <mat-icon
            class="icon-inline"
            [ngClass]="item.temVeiculoAtribuido ? 'color-ok' : 'color-pending'"
            [fontIcon]="item.temVeiculoAtribuido ? 'check_circle' : 'radio_button_unchecked'"
          />
          {{ item.temVeiculoAtribuido && item.veiculo ? item.veiculo.placa + ' - ' + item.veiculo.modelo + ' (' + item.veiculo.ano + ')' : 'Não atribuído' }}
        </span>
        <button mat-flat-button class="btn-tg-white" (click)="assignVehicle()">
          {{ item.temVeiculoAtribuido ? 'Trocar veículo' : 'Atribuir veículo' }}
        </button>
      </div>
    </div>

    @if (canConfirmar) {
      <div class="view-section">
        <div class="section-title">
          <mat-icon class="section-icon">task_alt</mat-icon>
          Confirmação
        </div>
        <div class="flex justify-between items-center">
          <span class="field-value text-sm text-gray-500">
            Revise motorista e veículo e confirme para enviar a OS pra conferência do Consultor Operacional.
          </span>
          <button
            mat-flat-button class="btn-tg"
            [disabled]="confirming || !item.temMotoristaAtribuido || !item.temVeiculoAtribuido"
            [matTooltip]="(!item.temMotoristaAtribuido || !item.temVeiculoAtribuido) ? 'Atribua motorista e veículo antes de confirmar' : ''"
            (click)="confirmarOs()"
          >
            @if (confirming) {
              <mat-spinner diameter="20" class="loading-spinner"></mat-spinner>
            } @else {
              Confirmar atribuição
            }
          </button>
        </div>
      </div>
    }

    <div class="view-section">
      <div class="section-title">
        <mat-icon class="section-icon">chat</mat-icon>
        Observação
      </div>
      <mat-form-field class="input-tg w-full" appearance="outline">
        <mat-label>Observação</mat-label>
        <textarea matInput [(ngModel)]="obsFornecedor" rows="3"></textarea>
      </mat-form-field>
      <div class="flex justify-end">
        <button mat-flat-button class="btn-tg-white" [disabled]="savingObs" (click)="saveObservacao()">
          @if (savingObs) {
            <mat-spinner diameter="20" class="loading-spinner"></mat-spinner>
          } @else {
            Salvar observação
          }
        </button>
      </div>
    </div>
  </mat-card>
}
